var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "q-modal",
        {
          attrs: {
            "content-css": {
              minWidth: _vm.getMinWidth,
              maxWidth: _vm.getMaxWidth,
              minHeight: "80vh"
            },
            "no-backdrop-dismiss": "",
            "no-esc-dismiss": ""
          },
          on: {
            show: function($event) {
              return _vm.clearQuestions()
            },
            hide: function($event) {
              return _vm.hideQuestionModal()
            }
          },
          model: {
            value: _vm.add_question,
            callback: function($$v) {
              _vm.add_question = $$v
            },
            expression: "add_question"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "fas fa-times"
                    },
                    on: {
                      click: function($event) {
                        return _vm.hideQuestionModal()
                      }
                    }
                  }),
                  _c("q-toolbar-title", [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("question")) +
                        "\n                "
                    )
                  ])
                ],
                1
              ),
              _c("div", { staticClass: "layout-padding" }, [
                _c("div", { staticClass: "row gutter-sm" }, [
                  _c(
                    "div",
                    { staticClass: "col-xs-12 col-sm-12" },
                    [
                      _c("q-select", {
                        attrs: {
                          options: _vm.test_types.map(function(e) {
                            return { label: _vm.$t(e.slug), value: e.value }
                          }),
                          "float-label": _vm.$t("question_type"),
                          error:
                            _vm.$v.presential_event_evaluation_question_type
                              .$error
                        },
                        on: {
                          input:
                            _vm.$v.presential_event_evaluation_question_type
                              .$touch
                        },
                        model: {
                          value: _vm.presential_event_evaluation_question_type,
                          callback: function($$v) {
                            _vm.presential_event_evaluation_question_type = $$v
                          },
                          expression:
                            "presential_event_evaluation_question_type"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-xs-12 col-sm-12" },
                    [
                      _c(
                        "q-field",
                        { attrs: { count: 256 } },
                        [
                          _c("q-input", {
                            attrs: {
                              "float-label": _vm.$t("title"),
                              error: _vm.$v.title.$error
                            },
                            on: { input: _vm.$v.title.$touch },
                            model: {
                              value: _vm.title,
                              callback: function($$v) {
                                _vm.title = $$v
                              },
                              expression: "title"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _c(
                  "div",
                  { staticClass: "row gutter-sm justify-end q-mt-lg" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "col-xs-12 col-sm-3",
                        class: _vm.getOrder("cancel")
                      },
                      [
                        _c("q-btn", {
                          staticClass: "full-width",
                          attrs: {
                            color: "tertiary",
                            label: _vm.$t("cancel"),
                            icon: "far fa-block"
                          },
                          on: {
                            click: function($event) {
                              return _vm.hideQuestionModal()
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "col-xs-12 col-sm-3",
                        class: _vm.getOrder("save")
                      },
                      [
                        _c("q-btn", {
                          staticClass: "full-width",
                          attrs: {
                            color: "secondary",
                            label: _vm.$t("save"),
                            icon: "far fa-save"
                          },
                          on: {
                            click: function($event) {
                              return _vm.saveQuestion()
                            }
                          }
                        })
                      ],
                      1
                    )
                  ]
                )
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }